import React from 'react';
import { Route, Switch, HashRouter as Router } from 'react-router-dom';

import Home from './Home';
import WhereToGetCare from './WhereToGetCare';

// Benefits
 
import CoveragePeriodsRates from './CoveragePeriodsRates';
import PlanDetails from './PlanDetails';
import Contact from './Contact';
import Eligibility from './Eligibility';
import BrandWelcome from './BrandWelcome';



export default class AppRouter extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/ABC" render={()=><BrandWelcome brand="ABC" path="/abc" />} />
        <Route exact path="/ABS" render={()=><BrandWelcome brand="ABCBS" path="/abs" />} />
        <Route exact path="/EBC" render={()=><BrandWelcome brand="EBC" path="/ebc" />} />
        <Route exact path="/EBS" render={()=><BrandWelcome brand="BCBS" path="/ebs" />} />
        
        <Route path="/coverage-periods-rates" component={CoveragePeriodsRates} />
        <Route path="/plan-details" component={PlanDetails} />
        <Route path="/care" component={WhereToGetCare} />
        <Route path="/Contacts" component={Contact} />
        <Route path="/eligibility" component={Eligibility} />
   </Switch>
    );
  }
}
